<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Pridelovalci</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            />
          </div>
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
     <div class="columnBar">
        Skriti stolpci:
              <kendo-multiselect 
                        :data-source="storedcolumns"
                        :data-text-field="'title'"
                        :data-value-field="'field'"
                        :placeholder="'Skrij stolpce'"
                         @select="skrijStolpec"
                        @deselect="prikaziStolpec"
                        :filter="'contains'"
                        :auto-width="true"
                        :value="hiddenColumns"
                        >
            </kendo-multiselect>
        </div>
    <div class="grid-wrapper">
    <Grid  
                       
                        :sortable="sortable"
                        :filterable="filterable"
                        :groupable="groupable"
                        :pageable="{ buttonCount: 4, pageSizes: [10,50,100] }"
                        :data-items="dataResult"
                        :skip="storedskip"
                        :take="storedtake" 
                        :sort="storedsort" 
                        :pageSize="pageSize"
                        :filter="filter" 
                        :columns="storedcolumns"
                        @datastatechange="dataStateChange"
                        @pagechange="pageChangeHandler"
                       :resizable="true"
                        
                  
                       
                        >
                     <template v-slot:cbItem="{props}">
                      <cbItem :checked="props.dataItem.jeaktivna"/>
                    </template>

                    <template v-slot:ukaziItem="{props}">
                      <ukazi :dataItem="props.dataItem" :key="props.dataItem.id" @prikaziSporocila="prikaziSporocila" :pravice="pravice"/>
                    </template>
                    
                        <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                     
                            <button 
                                title="Išči"
                                class="k-button k-primary"
                                @click="naloziPodatke"
                            >
                                Išči
                            </button>

                             <button v-if="userDetails.pravice.includes('PRIDELAVA_PISI')"
                                title="Dodaj KMG"
                                class="k-button k-primary"
                                @click="dodajPridelovalca"
                            >
                                Dodaj
                            </button>
                            <!--
                            <button v-if="userDetails.pravice.includes('PRIDELAVA_PISI')"
                                title="Prenesi iz prejšnje sezone"
                                class="k-button k-primary"
                                @click="dodajPridelovalca"
                            >
                                Prenesi iz prejšnje sezone
                            </button> -->
                             <button
                                title="Izvozi v Excel"
                                class="k-button k-primary"
                                @click="exportExcel"
                            >
                                Izvozi v Excel
                            </button>
                           
                        </div>
                            
                        </toolbar>
                    </Grid>
                    <div class="shema-loader" v-if="loading"><font-awesome-icon icon="circle-notch" spin="spin"/></div>
                    </div>
                    </div>

    <k-dialog v-if="sporocilaPrikazana" :title="'Napake in opozorila'" @close="skrijSporocila">
        <ul>
            <li v-for="s in sporocila" class="sporocilo">

                <button disabled v-if="s.vrstasporocila==0" class="k-primary k-button k-grid-edit-command" title="Obvestilo">
                         <font-awesome-icon icon="info"/>
                </button>
                <button disabled v-if="s.vrstasporocila==1" class="k-warning k-button k-grid-edit-command" title="Opozorilo">
                         <font-awesome-icon icon="exclamation"/>
                </button>
                <button disabled v-if="s.vrstasporocila==2" class="k-error k-button k-grid-edit-command" title="Napaka">
                         <font-awesome-icon icon="times"/>
                </button>
                <span>{{s.sporocilo}}</span>
            </li>
        </ul>
    </k-dialog>
    </div>
   

</template>
<style type="text/css">
    .sporocilo {
            display: flex;
    align-items: center;
    align-content: center;
    flex-direction: row;

    }
    .sporocilo button{
        width: 25px;
        margin-right: 10px;
    }
</style>
<script>
import { mapState, mapActions,mapMutations } from 'vuex'

import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';

import kulture from './support/kulture-data';
import { Grid, GridToolbar,GridNoRecords } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
//import { saveExcel } from '@progress/kendo-vue-excel-export';
import { MultiSelect } from '@progress/kendo-dropdowns-vue-wrapper';
import CheckBoxGridItem from './support/CheckBoxGridItem';
Vue.component('kendo-multiselect', MultiSelect);

import { process } from '@progress/kendo-data-query';
import PridelavaUkazi from './support/PridelavaUkazi';
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
import { Button } from '@progress/kendo-vue-buttons';






export default {
     props:["sezona"],
      components:{
      'k-dialog': Dialog,
      'dialog-actions-bar': DialogActionsBar,
      'dropdownlist': DropDownList,
      'cbItem': CheckBoxGridItem,
      'ukazi':PridelavaUkazi,
  //    'sifkontroleddcell': SifrantKontroleDownCell,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
 
  },
    data () {
        return {
            dataSezona:this.sezona,
            loading:false,
          
           
            girdDataApi:null,
            gridData:null,
            sporocilaPrikazana:false,

             
            editID: null,
            //skip: 0,
            //take: 10,
            pageSize: 10,
            sortable: true,
            filterable: true,
            groupable: false,
            
            expandedItems: [],
            dataResult: [],
         
            //sort: [
                //{ field: 'ime', dir: 'asc' }
            //],
           

           

        }
    },
    mounted (){

           const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
            filter: this.filter,
            
        };
        

        this.dataResult = process( this.pridelava, dataState);
    },
    created () {

    
      if(!this.sezona)
        this.dataSezona={sezona:Math.max(...this.sezonePisanje.map(s=>s.sezona))};
      else
      this.dataSezona={sezona:this.sezona};



    let columns=[
                
                { title: this.pravice?"Ukazi":"Stanje", cell: "ukaziItem",filterable:false,columnMenu: null,width:this.pravice?"270px":"60px",sortable:false},
                { field: "kmgmid", title:"KMG-MID", width:"210px" },
                { field: "kontrolnastevilka", title:"Kontrolna št."},
                { field: "imenosilca", title:"Ime nosilca"},
                { field: "naslov", title:"Naslov KMG",},
                { field: "postnastevilka", title:"Poštna št. KMG"},
                { field: "posta", title:"Pošta KMG"},
                { field: "obcina", title:"Občina KMG",hidden:true},
                { field: "statisticnaregija", title:"Statistična regija KMG"},
                { field: "naslovnosilca", title:"Naslov nosilca",hidden:true},
                { field: "postnastevilkanosilca", title:"Poštna št. nosilca",hidden:true},
                { field: "postanosilca", title:"Pošta nosilca",hidden:true},
                { field: "statuspridelovalca", title:"Status"},
                { field: "datumdolocitvestatusa", title:"Datum določitve statusa", filterable:false, type:"date",format: '{0:d}', hidden:true},
                //{ field: "ds", title:"Davčna številka",hidden:true},
                //{ field: "emso", title:"Emšo",hidden:true},
                //{ field: "vrstaPridelovalca", title:"Vrsta pridelovalca",hidden:true},
                { field: "imavezanezivali", title:"Vezana reja",hidden:true},
                { field: "imatravojedezivali", title:"Travojede živali",hidden:true},
                { field: "jeaktivna", title:"V kontroli",cell:"cbItem", hidden:true},
                
                
            ];

           // if(this.userDetails.pravice.includes("PRIDELAVA_PISI"))
             //   columns.unshift({ title: "Ukazi", cell: "ukaziItem",filterable:false,columnMenu: null,width:"270px",sortable:false});

            if(this.userDetails.pravice.includes("STATISTIKA_BERI"))
                columns.push({ field: "kontrolnaorganizacija", title:"V kontroli pri"});

            console.log("Klical se je created!!!");
            if(this.storedcolumns.length==0)
                this.updatecolumns(columns);

            //return columns;

        
    /*         


        
    
     this.load(this.dataSezona);
     */



    },
    computed: {
        filter:{
            get(){
                return this.storedfilter;
            },
            set(value){
                this.updatefilter(value);
            }
        },
        skip:{
            get(){
                return this.storedskip;
            },
            set(value){
                this.updateskip(value);
            }
        },
        sort:{
            get(){
                return this.storedsort;
            },
            set(value){
                this.updatesort(value);
            }
        },
        take:{
            get(){
                return this.storedtake;
            },
            set(value){
                this.updatetake(value);
            }
        },
        pravice:{
            get(){
                return this.userDetails?.pravice?.includes("PRIDELAVA_PISI");
            },
            
        },
        
        ...mapState('pridelava', ['pridelava','storedfilter','storedcolumns','storedskip','storedtake','storedsort']),
        ...mapState('users', ['userDetails','sezonePisanje']),
        hiddenColumns() {
            return this.storedcolumns.filter(c=>c.hidden);
        },
        /*
        columns() {

            let columns=[
                
                
                { field: "kmgmid", title:"KMG-MID", width:"210px" },
                { field: "kontrolnastevilka", title:"Kontrolna št."},
                { field: "imenosilca", title:"Ime nosilca"},
                { field: "naslov", title:"Naslov KMG",},
                { field: "postnastevilka", title:"Poštna št. KMG"},
                { field: "posta", title:"Pošta KMG"},
                { field: "obcina", title:"Občina KMG",hidden:true},
                { field: "statisticnaregija", title:"Statistična regija KMG"},
                { field: "naslovnosilca", title:"Naslov nosilca",hidden:true},
                { field: "postnastevilkanosilca", title:"Poštna št. nosilca",hidden:true},
                { field: "postanosilca", title:"Pošta nosilca",hidden:true},
                { field: "statuspridelovalca", title:"Status"},
                { field: "datumdolocitvestatusa", title:"Datum določitve statusa", filterable:false, type:"date",format: '{0:d}', hidden:true},
                //{ field: "ds", title:"Davčna številka",hidden:true},
                //{ field: "emso", title:"Emšo",hidden:true},
                //{ field: "vrstaPridelovalca", title:"Vrsta pridelovalca",hidden:true},
                { field: "imavezanezivali", title:"Vezana reja",hidden:true},
                { field: "imatravojedezivali", title:"Travojede živali",hidden:true},
                { field: "jeaktivna", title:"V kontroli",cell:"cbItem", hidden:true},
                
                
            ];

            if(this.userDetails.pravice.includes("PRIDELAVA_PISI"))
                columns.unshift({ title: "Ukazi", cell: "ukaziItem",filterable:false,columnMenu: null,width:"270px",sortable:false});

            if(this.userDetails.pravice.includes("STATISTIKA_BERI"))
                columns.push({ field: "kontrolnaorganizacija", title:"V kontroli pri"});


            

            return columns;


        }
*/
           },
      watch: {
       
        sezonePisanje(newValue, oldValue){
            this.sezona=Math.max(...this.sezonePisanje.map(s=>s.sezona));
            this.dataSezona={sezona:this.sezona};
        }
         ,
        skip(newValue, oldValue){
           

            const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
        },
        take(newValue, oldValue){
         
       /*  if(isNaN(this.take))
            this.take=this.pridelava.length;
         */   
            const dataState = {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                 filter: this.filter,
                group: this.group
            }
        this.dataResult = process( this.pridelava, dataState);
        },
       pridelava(newValue, oldValue) {
    

      if(newValue){
        const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
        }
    }
},
    methods: {

        ...mapActions('pridelava', ['load','replace']),
        ...mapMutations('pridelava',['updatefilter','updatecolumns','updatesort','updatetake','updateskip']),
        prikaziSporocila:function(e){
            
            this.sporocila=e;
            this.sporocilaPrikazana=true;

        },
        skrijSporocila:function(e){
            this.sporocilaPrikazana=false;

        },
        naloziPodatke: function(e){
            this.loading=true;
            if(!this.sezona)
                this.dataSezona={sezona:Math.max(...this.sezonePisanje.map(s=>s.sezona))};
            else
                this.dataSezona={sezona:this.sezona};
         this.load(this.dataSezona).then(()=>this.loading=false);
        },
         skrijStolpec: function(e) {
            let column=this.storedcolumns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=true;
                const dataState = {
            skip: this.skip,
            take: this.take,
             filter: this.filter,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
           //console.log(this.storedcolumns);
        },
        prikaziStolpec: function(e) {
           let column=this.storedcolumns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=false;
                const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
        },
        sezonaChange(event) {
            const sezona = event.value;
            this.$router.push({ name: 'pridelava', params: { sezona:sezona.sezona} })
            this.dataSezona=sezona;
            //this.load({sezona:this.dataSezona.sezona});
            
     


        },

        
        createAppState: function(dataState) {
           
            this.take = dataState.take;
            this.skip = dataState.skip?dataState.skip:0;
            if (dataState.group) {
                dataState.group.map(group => group.aggregates = this.aggregates);
            }
            this.group = dataState.group;
            this.filter = dataState.filter;
            this.sort = dataState.sort;
           
        },

        dataStateChange (event) {
            this.createAppState(event.data);
          
            this.dataResult = process(this.pridelava, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });
          

        },
        formatDate: function (h, emptyElement , props, listeners ) {
          
             return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
        dodajPridelovalca(){

              this.$router.push({ name: 'dodajPridelovalca', params: this.dataSezona })

        },
        exportExcel () {
              this.loading=true;
            var thisApp=this;
            this.saveExcel({
                data: process(this.pridelava, {
                
                sort: this.sort,
                filter: this.filter,
                group: this.group
            }).data,
                fileName:this.dataSezona.sezona+ "_PRIDELOVALCI",
                columns: this.storedcolumns.filter(i=>!i.hidden),
                 onExportComplete:function(){thisApp.loading=false;}
            });
        },

         pageChangeHandler: function(event) {
            
            //this.skip = event.page.skip;
            this.updateskip(event.page.skip);
            this.updatetake(event.page.take);
            //this.take = event.page.take;
           
        },
        filterchange: function(ev) {

            this.updatefilter(ev);
        },
        
    }
};
</script>

